export default __webpack_public_path__ + "images/5f78d1ba80453cb67513c634c2fb0b92-boston_desktop.webp";